import { SelectInputOption } from '@/components/inputs/SelectInput';
import { USER_TYPE_LABELS, type UserTypeFilter } from '../enums/UserType';

export const userTypeOptions: SelectInputOption[] = [
  { label: USER_TYPE_LABELS.commerce, value: 'commerce' satisfies UserTypeFilter },
  { label: USER_TYPE_LABELS.operator, value: 'operator' satisfies UserTypeFilter },
  {label: USER_TYPE_LABELS.external_operator, value: 'external_operator' satisfies UserTypeFilter},
];
